import React from "react";

const ChevronLeft = ({
    width = 21,
    height = 21,
    color = "#70707A",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8216 4.56836C13.5699 4.3526 13.1909 4.38175 12.9752 4.63347L8.17276 10.2363C7.98007 10.4611 7.98007 10.7928 8.17276 11.0176L12.9752 16.6204C13.1909 16.8721 13.5699 16.9013 13.8216 16.6855C14.0733 16.4697 14.1025 16.0908 13.8867 15.8391L9.41918 10.6269L13.8867 5.41481C14.1025 5.16309 14.0733 4.78412 13.8216 4.56836Z" fill={color}/>
            
        </svg>
    )
}

export default ChevronLeft;